// @flow
export { default } from './SettingsTemplate';



// WEBPACK FOOTER //
// ./src/components/settings/SettingsTemplate/index.js